






























import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Form } from '../models/Form';

@Component({
    name: 'ElementIntro',
    computed: mapGetters(['form']),
})
export default class ElementIntro extends Vue {
    error: string = '';
    apiUrl: string = process.env.VUE_APP_API_URL;
}
